"use client"

import { Icon } from "@/components/ui/icon"
import { Button } from "@heroui/react"
import { useState } from "react"

export function ErrorCard({ message }: { message: string }) {
  const [errorReported, setErrorReported] = useState(false)

  function sendErrorReport(): void {
    setErrorReported(true)
    // Log error to console for debugging
    console.error('Error reported:', {
      error: message,
      context: 'ErrorComponent',
      meta: {
        url: window.location.href
      }
    })
  }

  function goHome(): void {
    window.location.href = '/'
  }




  return (
    <div className="flex flex-col gap-3 justify-center items-center m-auto">
      <div className="flex gap-3 items-center">
        <Icon icon="danger-triangle" className="w-6 h-6 text-danger" />
        <p className="font-medium text-large">Error Encountered</p>
      </div>
      <div className="flex flex-col gap-2 px-2">
        <p className="font-medium text-large">Oops! Something went wrong.</p>
        <p className="text-small text-foreground/60">
          {message}
        </p>
      </div>


      {!errorReported ? <Button
        fullWidth
        variant="danger"
        onPress={sendErrorReport}
      >
        Report Error
      </Button> : <Button
        fullWidth
        onPress={goHome}
      >
        Home
      </Button>}
    </div>
  )
}
